import { render } from "./section-2.vue?vue&type=template&id=f91a53e0&scoped=true"
import script from "./section-2.vue?vue&type=script&lang=js"
export * from "./section-2.vue?vue&type=script&lang=js"

import "./section-2.vue?vue&type=style&index=0&id=f91a53e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f91a53e0"]])

export default __exports__